<template>
  <div id="selector-etiquetas-app">
    <table class="pure-table pure-table-bordered">
      <tbody>
        <tr>
          <td class="c1"><ion-title>Zona</ion-title></td>
          <td colspan="2" class="detalle">
            <ion-select v-model="zona" placeholder="Elije zona" interface="action-sheet" mode="ios" @ionChange="emitir">
              <ion-select-option v-for="(op, index) in opciones" :value="op" :key="index">{{ op }}</ion-select-option>
            </ion-select>
          </td>
        </tr>
        <tr>
          <td class="c1"><ion-title>Pasillo</ion-title></td>
          <td colspan="2" class="detalle">
            <ion-select v-model="pasillo" placeholder="Elije pasillo" interface="action-sheet" mode="ios" @ionChange="emitir">
              <ion-select-option v-for="(ps, index) in pasillos" :value="ps" :key="index">{{ pad2(ps) }}</ion-select-option>
            </ion-select>
          </td>
        </tr>
        <tr>
          <td class="c1"><ion-title>Estante</ion-title></td>
          <td class="detalle" :colspan="single ? 2 : 1">
            <ion-row><ion-label>Desde</ion-label></ion-row>
            <ion-select v-model="e0" interface="action-sheet" mode="ios" @ionChange="emitir">
              <ion-select-option v-for="(ps, index) in estantes" :value="ps" :key="index">{{ pad2(ps) }}</ion-select-option>
            </ion-select>
          </td>
          <td class="detalle" v-if="!single">
            <ion-row><ion-label>Hasta</ion-label></ion-row>
            <ion-select v-model="e1" interface="action-sheet" mode="ios" @ionChange="emitir" :disabled="single">
              <ion-select-option v-for="(ps, index) in estantes.filter(x => x >= e0)" :value="ps" :key="index">{{ pad2(ps) }}</ion-select-option>
            </ion-select>
          </td>
        </tr>
        <tr>
          <td class="c1"><ion-title>Altura</ion-title></td>
          <td class="detalle" :colspan="single ? 2 : 1">
            <ion-row><ion-label>Desde</ion-label></ion-row>
            <ion-select v-model="a0" interface="action-sheet" mode="ios" @ionChange="emitir">
              <ion-select-option v-for="(ps, index) in pasillos" :value="ps" :key="index">{{ pad2(ps) }}</ion-select-option>
            </ion-select>
          </td>
          <td class="detalle" v-if="!single">
            <ion-row><ion-label>Hasta</ion-label></ion-row>
            <ion-select v-model="a1" interface="action-sheet" mode="ios" @ionChange="emitir" :disabled="single">
              <ion-select-option v-for="(ps, index) in pasillos.filter(x => x >= a0)" :value="ps" :key="index">{{ pad2(ps) }}</ion-select-option>
            </ion-select>
          </td>
        </tr>
        <tr>
          <td class="c1"><ion-title>Posicion</ion-title></td>
          <td class="detalle" :colspan="single ? 2 : 1">
            <ion-row><ion-label>Desde</ion-label></ion-row>
            <ion-select v-model="p0" interface="action-sheet" mode="ios" @ionChange="emitir">
              <ion-select-option v-for="(po, index) in posiciones" :value="po" :key="index">{{ pad2(po) }}</ion-select-option>
            </ion-select>
          </td>
          <td class="detalle" v-if="!single">
            <ion-row><ion-label>Hasta</ion-label></ion-row>
            <ion-select v-model="p1" interface="action-sheet" mode="ios" @ionChange="emitir" :disabled="single">
              <ion-select-option v-for="(po, index) in posiciones.filter(x => x >= p0)" :value="po" :key="index">{{ pad2(po) }}</ion-select-option>
            </ion-select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TablaUbicacion',
  props: {
    zonaInit: { type: String, default: 'ZOA' },
    pasilloInit: { type: Number, default: 0 },
    e0Init: { type: Number, default: 0 },
    e1Init: { type: Number, default: undefined },
    a0Init: { type: Number, default: 0 },
    a1Init: { type: Number, default: undefined },
    p0Init: { type: Number, default: undefined },
    p1Init: { type: Number, default: undefined },
    single: { type: Boolean, default: false }
  },
  emits: ['change'],
  data () {
    return {
      opciones: ['ALT', 'BOB', 'BOX', 'CAL','CAN', 'CBO', 'CEX', 'CPP', 'CRB', 'CRS', 'CRO', 'DEV', 'EXP', 'EXT', 'FRO', 'PAL', 'PRE', 'REC', 'RUT', 'SOT', 'SUE', 'PCI', 'VER', 'TIE', 'TUB', 'ZOA', 'ZOB', 'ZOC', 'ZOD'],
      pasillos: [...Array(51).keys()],
      estantes: [...Array(51).keys()],
      posiciones: [...Array(26).keys()],
      zona: this.zonaInit,
      pasillo: this.pasilloInit,
      e0: this.e0Init,
      e1: this.e1Init,
      a0: this.a0Init,
      a1: this.a1Init,
      p0: this.p0Init,
      p1: this.p1Init
    }
  },
  methods: {
    pad2 (n) { return (`0${Number(n||0)}`).slice(-2) },
    componer (a) {
      const resu = a.length === 3
        ? `${a[0]} ${this.pad2(a[1])} ${this.pad2(a[2])}`
        : `${a[0]} ${this.pad2(a[1])} ${this.pad2(a[2])} ${this.pad2(a[3])}`
      return resu
    },
    emitir () {
      const pasStr = this.pad2(this.pasillo)
      const zonaBase = `${this.zona}${pasStr}`
      const ests = this.single
        ? [this.e0 ?? 0]
        : [...Array(51).keys()].filter(v => v >= (this.e0 ?? 0) && (this.e1 === undefined ? true : v <= this.e1))
      const alts = this.single
        ? [this.a0 ?? 0]
        : [...Array(51).keys()].filter(v => v >= (this.a0 ?? 0) && (this.a1 === undefined ? true : v <= this.a1))
      const poss = this.single
        ? (this.p0 === undefined ? undefined : [this.p0])
        : (this.p0 === undefined ? undefined : [...Array(26).keys()].filter(v => v >= this.p0 && (this.p1 === undefined ? true : v <= this.p1)))
      let composedRange
      if (poss && poss.length > 0) {
        composedRange = []
        for (const e of ests) for (const a of alts) for (const p of poss) composedRange.push(this.componer([zonaBase, e, a, p]))
      } else {
        composedRange = []
        for (const e of ests) for (const a of alts) composedRange.push(this.componer([zonaBase, e, a]))
      }
      const single = this.componer([zonaBase, (this.e0 ?? 0), (this.a0 ?? 0)].concat(this.p0 !== undefined ? [this.p0] : []))
      this.$emit('change', {
        zona: this.zona,
        pasillo: this.pasillo,
        e0: this.e0,
        e1: this.single ? undefined : this.e1,
        a0: this.a0,
        a1: this.single ? undefined : this.a1,
        p0: this.p0,
        p1: this.single ? undefined : this.p1,
        composedRange,
        composedSingle: single
      })
    }
  },
  mounted () { this.emitir() }
})
</script>

<style scoped>
table { width: 100% !important; }
tr { height: 5rem !important; }
td.c1 { width: 38% !important }
td.detalle { text-align: center; width: 31% !important; }
ion-title { padding-left: 4px !important; padding-right: 4px !important; position: relative }
ion-label { font-size: 1.2rem !important; padding: 4px !important; margin: 4px !important; text-align: center; width: 100% !important; }
ion-select { border: 1px solid var(--ion-color-light) !important; font-size: 1.4rem !important; width: 100% !important; }
</style>
